/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid, DialogContentText } from '@material-ui/core';
import { Table, DialogDefault, CustomFilter } from '../../components';
import * as selectorsAuth from '../../store/auth/reducer';
import * as actionsProgramacaoDiarias from '../../store/programacaoDiaria/actions';
import Formulario from './Formulario';
import moment from 'moment';
import * as Roles from '../../constants/role';
import { isNotAdmin } from 'utils';
import { TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO, TIPO_PROGRAMACAO_DIARIA_INSPECAO, TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS } from '../../constants/ids';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main
  },
  iconValidate: {
    marginRight: theme.spacing(1),
    color: 'green'
  },
  iconInvalidate: {
    marginRight: theme.spacing(1),
    color: 'red'
  }
}));

const defaultFilter = authData => ({ 
  inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
  fim: moment().endOf('month').valueOf(),
  usuarioId: isNotAdmin(authData.role) ? [authData.id] : [],
})

const ProgramacaoDiarias = ({ exportProgramacaoDiaria, authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [titles] = useState(['Data', 'Inspetor', 'Tipo da Programação', 'Descrição do Tipo', 'Descrição']);
  const [localFilter, setLocalFilter] = useState({
    inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
    fim: moment().endOf('day').valueOf()
  });
  const [openExport, setOpenExport] = useState(false);
  const [reload, setReload] = useState(null);

  const classes = useStyles();
  
  const renderDescricaoTipo = d => {
    if (TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === d.tipoId) {
      return <>
        <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> De: </span>
        <span style={{ marginRight: '5px', fontSize: 12 }}> {d.cidadeDe} </span>
        <br/>
        <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> Para: </span>
        <span style={{ marginRight: '5px', fontSize: 12 }}> {d.cidadePara} </span>
      </>
    } else if (TIPO_PROGRAMACAO_DIARIA_INSPECAO === d.tipoId) {
      return <>
        <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> Nsirs: </span>
        <span style={{ marginRight: '5px', fontSize: 12 }}> {d.nsirCodes.join(', ')} </span>
      </>
    } else if (TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === d.tipoId) {
      return <>
        <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> Veiculo: </span>
        <span style={{ marginRight: '5px', fontSize: 12 }}> {d.veiculo} </span>
      </>
    }

    return "-"
  }

  const renderRows = d => {
    return (
      <>
        <TableCell size="small">
            <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> {d.referenceDayFormat} </span>
            <br/>
            <span style={{ marginRight: '5px', fontSize: 12 }}> Criado em {d.createdAt} </span>
          </TableCell>
        <TableCell size="small">
            <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> Inspetor: </span>
            <span style={{ marginRight: '5px', fontSize: 12 }}> {d.inspetorName} </span>
            {d.inspetorAuxiliarName && <>
              <br/>
              <span style={{ marginRight: '5px', fontSize: 12, fontWeight: 'bold' }}> Ajudante/Observador: </span>
              <span style={{ marginRight: '5px', fontSize: 12 }}> {d.inspetorAuxiliarName} </span>
            </>}
        </TableCell>
        <TableCell><span style={{ marginRight: '5px', fontSize: 12 }}> {d.tipo} </span></TableCell>
        <TableCell><span style={{ marginRight: '5px', fontSize: 12 }}> {renderDescricaoTipo(d)} </span></TableCell>
        <TableCell><span style={{ marginRight: '5px', fontSize: 12 }}> {d.descricao || '-'} </span></TableCell>
      </>
    )
  }

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = isSave => {
    if (isSave) {
      setReload(!reload);
    }

    setOpen(false);
    setId(null);
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <CustomFilter
            onFilter={filterData => setLocalFilter(filterData)}
            fields={[
              { field: "useDates", useDateTypes: false, useDateTypesReadOnly: true },
              { field: "useUsuarios", md: 6, xs: 6, multiSelect: true, disabled: (Roles.ADMIN !== authData.role && Roles.SUPER_ADMIN !== authData.role) },
              { field: "useOption", md: 6, xs: 6, code: "TIPO_PROGRAMACAO_DIARIA", label: "Tipo da Programação", key: "tipoIds" },
              { field: "useNsirs", md: 6, xs: 6 },
              { field: "useMalha", md: 6, xs: 6, multiSelect: true },
              { field: "useGerencia", md: 6, xs: 6, multiSelect: true },
              { field: "usePolo", md: 6, xs: 6, multiSelect: true },
              { field: "useTipoServico", md: 6, xs: 6 },
            ]}
            defaultFilter={defaultFilter(authData)}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={[]}
          titles={titles}
          headerTitle="Programação Diária"
          showDelete={false}
          renderRows={renderRows}
          onAdd={onAdd}
          onEdit={onEdit}
          hasRowActions
          headerActions={[{ 
            title: 'Exportar',
            onClick: () => setOpenExport(true)
          }]}
          usePaginationApi
          paginationApi="programacao-diaria/filter"
          paginationUrl="programacao-diaria"
          filterData={localFilter}
          reload={!reload}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
        />
      </Grid>
      <DialogDefault
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => {
          exportProgramacaoDiaria(localFilter, () => {
            setOpenExport(false);
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja baixar todas as informações filtradas? </DialogContentText>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsProgramacaoDiarias,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProgramacaoDiarias));
